module.exports = __webpack_public_path__ + "static/media/EVEN.e741711b.png";